// Hideo - image files: an image file shrunk to a small JPEG (readImg: the image boxes, the idea box, a file dropped to
// create a video, old Base64 images moved out of the data) and the guard that keeps a file dropped outside a box from
// opening in place of the app. Ported from the legacy core/utils.js (verbatim copy in tests/fixtures/legacy/utils-w12.js).

/** Image file → JPEG data URL (quality 0.8), at most `max` pixels on its longer side (never enlarged) */
export function readImg(file: Blob, max = 800): Promise<string> {
  return new Promise(res => {
    const r = new FileReader()
    r.onload = e => {
      const img = new Image()
      img.onload = () => {
        const k = Math.min(1, max / Math.max(img.width, img.height)), c = document.createElement('canvas')
        c.width = img.width * k; c.height = img.height * k
        ;(c.getContext('2d') as CanvasRenderingContext2D).drawImage(img, 0, 0, c.width, c.height)
        res(c.toDataURL('image/jpeg', 0.8))
      }
      img.src = (e.target as FileReader).result as string
    }
    r.readAsDataURL(file)
  })
}

/** The drag carries files (from the computer), not text or an element of the page */
export const hasFiles = (e: DragEvent): boolean => !!e.dataTransfer && [...e.dataTransfer.types].includes('Files')

/** A file or blob → data URL */
export const blobToDataUrl = (b: Blob): Promise<string> => new Promise((res, rej) => {
  const r = new FileReader()
  r.onload = () => res(r.result as string)
  r.onerror = () => rej(r.error)
  r.readAsDataURL(b)
})

/** A file dropped outside a box must not open the image in place of the app (work in progress would be lost): the
 *  window's dragover and drop are cancelled when they carry files. Installed once while the app loads (src/features/boot.ts) */
export function installFileDropGuard(win: Pick<Window, 'addEventListener'>): void {
  win.addEventListener('dragover', e => { if (hasFiles(e)) e.preventDefault() })
  win.addEventListener('drop', e => { if (hasFiles(e)) e.preventDefault() })
}
